export const de = {
  title: "Cluster-Übersicht",
  newTenant: "+ Neuer Mandant",
  kpi: {
    activeTenants: "Aktive Mandanten",
    readySuffix: "bereit",
    degradedSuffix: "eingeschränkt",
    operatorHealth: "Operator Health",
    components: "Komponenten",
    installedSuffix: "installiert",
    podsRunning: "Pods Running",
    unhealthySuffix: "fehlerhaft",
  },
  tenantStatus: {
    title: "Mandanten-Status",
    empty: "Keine Mandanten vorhanden.",
    table: {
      tenant: "Mandant",
      namespace: "Namespace",
      phase: "Phase",
      apps: "Apps",
      edition: "Edition",
      created: "Erstellt",
      actions: "Aktionen",
      details: "Details",
    },
  },
  events: {
    title: "Letzte Ereignisse",
    empty: "Keine Ereignisse.",
  },
  resources: {
    title: "Cluster-Ressourcen",
    cpu: "CPU",
    memory: "Memory",
    nodes: "Nodes",
    hint: "Angefragte Ressourcen (Pod-Requests) gegen die zuteilbare Kapazität der Nodes.",
    driftDetected: "Drift erkannt",
  },
} as const;

export const en = {
  title: "Cluster Overview",
  newTenant: "+ New Tenant",
  kpi: {
    activeTenants: "Active Tenants",
    readySuffix: "ready",
    degradedSuffix: "degraded",
    operatorHealth: "Operator Health",
    components: "Components",
    installedSuffix: "installed",
    podsRunning: "Pods Running",
    unhealthySuffix: "unhealthy",
  },
  tenantStatus: {
    title: "Tenant Status",
    empty: "No tenants exist yet.",
    table: {
      tenant: "Tenant",
      namespace: "Namespace",
      phase: "Phase",
      apps: "Apps",
      edition: "Edition",
      created: "Created",
      actions: "Actions",
      details: "Details",
    },
  },
  events: {
    title: "Recent Events",
    empty: "No events.",
  },
  resources: {
    title: "Cluster Resources",
    cpu: "CPU",
    memory: "Memory",
    nodes: "Nodes",
    hint: "Requested resources (pod requests) against the nodes' allocatable capacity.",
    driftDetected: "Drift detected",
  },
} as const;
